// removed by extract-text-webpack-plugin
module.exports = {"displaySquareDisabled":"valueSquare__displaySquareDisabled___3sSnh","displaySquareUnselected":"valueSquare__displaySquareUnselected___24I3p","displaySquareSelected":"valueSquare__displaySquareSelected___167d6","displaySquareUnselectedNoHover":"valueSquare__displaySquareUnselectedNoHover___3RjF4","displaySquareSelectedNoHover":"valueSquare__displaySquareSelectedNoHover___B4hWd","displayText":"valueSquare__displayText___2_-m6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/valueSquare.css
// module id = 235
// module chunks = 0